import { apiRequest } from ".";


export const submitCase = async (token, data)=>{
    try {
        const response = apiRequest({
            url: '/case',
            method: 'POST',
            data: data,
            token,
            header: 'multipart/form-data',
        })

        return response
    } catch (error) {
        console.log(error)
    }
}
// get all cases for a specific user
export const fetchUserCases = async (token)=>{
    try {
        const response = apiRequest({
            url: '/case/user',
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const fetchAllCases = async (token)=>{
    try {
        const response = apiRequest({
            url: '/case',
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}

export const updateCase = async (token, caseId, data)=> {
    try {
        const response = apiRequest({
            url:`/case/${caseId}`, 
            method:'PUT', 
            data: data, // need to send an empty object if no changes are made
            token
        })

        return response
    } catch (error) {
        console.log(error)
    }
}



